/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Unprocessable entity
 * @export
 * @interface GetMarketsRegionIdOrdersUnprocessableEntity
 */
export interface GetMarketsRegionIdOrdersUnprocessableEntity {
    /**
     * Unprocessable entity message
     * @type {string}
     * @memberof GetMarketsRegionIdOrdersUnprocessableEntity
     */
    error?: string;
}

/**
 * Check if a given object implements the GetMarketsRegionIdOrdersUnprocessableEntity interface.
 */
export function instanceOfGetMarketsRegionIdOrdersUnprocessableEntity(value: object): value is GetMarketsRegionIdOrdersUnprocessableEntity {
    return true;
}

export function GetMarketsRegionIdOrdersUnprocessableEntityFromJSON(json: any): GetMarketsRegionIdOrdersUnprocessableEntity {
    return GetMarketsRegionIdOrdersUnprocessableEntityFromJSONTyped(json, false);
}

export function GetMarketsRegionIdOrdersUnprocessableEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMarketsRegionIdOrdersUnprocessableEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetMarketsRegionIdOrdersUnprocessableEntityToJSON(json: any): GetMarketsRegionIdOrdersUnprocessableEntity {
    return GetMarketsRegionIdOrdersUnprocessableEntityToJSONTyped(json, false);
}

export function GetMarketsRegionIdOrdersUnprocessableEntityToJSONTyped(value?: GetMarketsRegionIdOrdersUnprocessableEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

